import { jsx as _jsx } from "react/jsx-runtime";
// Temporary context solution for the CartMini. To be removed once design tokens are implemented.
import { createContext, useMemo } from "react";
import { useDetectTheme } from "@jti/ui";
export const CartMiniContext = createContext(undefined);
export const ThemeVariantProvider = ({ children }) => {
    const { isDarkTheme } = useDetectTheme();
    const contextValue = useMemo(() => ({
        isDarkTheme,
    }), [isDarkTheme]);
    return _jsx(CartMiniContext.Provider, { value: contextValue, children: children });
};
//# sourceMappingURL=CartMiniContext.js.map